import { createFileRoute } from '@tanstack/react-router';

import { LocationAssignmentsPage } from '../modules/location-assignments/ui/pages/LocationAssignmentsPage';

// NOTE: .index.tsx naming is REQUIRED here (same as zones route).
// Without the .index suffix, TanStack Router treats the file as a layout
// component and wraps all child routes instead of rendering the page.
// See JQ4-11 WU-13 gotcha.
//
// This route is NOT registered in navigation.ts — it is a sub-page of
// Locations, accessible only via the "Manage assignments" row action.
export const Route = createFileRoute(
  '/_authenticated/dashboard/locations/$locationId/assignments/',
)({
  component: LocationAssignmentsPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Assignments'],
  },
});
